import { useState, useEffect } from 'react';

import { getAppIdentifier } from '~/utils/devcenter';

const COMPONENTS = {};
const FINISH_LOADING_HANLDERS_BY_APP_NAME = {};

const LOCAL_DEBUG_URL = 'http://127.0.0.1:3000/app.js';

const useDevCenterApp = ({ CLIAppComponent, CLIAppSettings, app, version }) => {
  const appKey = app.app.app_key;

  const isLocalDebugMode = process.env.REACT_APP_DEBUG_DC_APP_KEY === appKey;
  const url = isLocalDebugMode ? LOCAL_DEBUG_URL : app?.package?.url;

  const appName = getAppIdentifier({ appKey, version, isLocalDebugMode });
  const [isLoading, setIsLoading] = useState(false);

  const appSource = COMPONENTS[appName];
  const AppComponent = CLIAppComponent || appSource?.component || null;
  const AppSettings = CLIAppSettings || appSource?.settings || null;

  const finishLoading = () => {
    setIsLoading(false);
    (FINISH_LOADING_HANLDERS_BY_APP_NAME[appName] || []).forEach(handler => handler());
    delete FINISH_LOADING_HANLDERS_BY_APP_NAME[appName];
  };

  useEffect(() => {
    if (appName in FINISH_LOADING_HANLDERS_BY_APP_NAME) {
      setIsLoading(true);
      FINISH_LOADING_HANLDERS_BY_APP_NAME[appName].push(() => {
        setIsLoading(false);
      });
    }
  }, []);

  useEffect(() => {
    if (
      !url ||
      !appName ||
      (AppComponent && AppSettings) ||
      appName in FINISH_LOADING_HANLDERS_BY_APP_NAME
    )
      return;

    if ((!CLIAppComponent && !appSource) || appSource?.component) {
      setIsLoading(true);

      if (!appSource || !appSource.script) {
        const scriptFile = document.createElement('script');

        scriptFile.src = url;

        scriptFile.onload = () => {
          COMPONENTS[appName] = window[appName] && window[appName].default;
          finishLoading();
        };

        COMPONENTS[appName] = {
          component: null,
          script: scriptFile,
        };

        setTimeout(() => document.body.appendChild(scriptFile));
      }

      const { script } = COMPONENTS[appName];

      if (script.onload) {
        const loaderCallback = script.onload;
        script.onload = () => {
          loaderCallback();
          finishLoading();
        };
      }

      script.onabort = finishLoading;

      script.error = finishLoading;
    }

    FINISH_LOADING_HANLDERS_BY_APP_NAME[appName] = [() => setIsLoading(false)];
  }, [url]);

  return {
    isLoading,
    AppComponent,
    AppSettings,
  };
};

export default useDevCenterApp;
